/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  VzzYJk: 'Create',
  'goal-create-success-flag-action': 'Go to goal',
  'goal-create-success-flag-title': 'Goal has been created',
  'navigation.universal-create.menuItemLoading': 'Menu item is loading',
  'platform.navigation-experiences.universal-create.integrations.form-loading': 'Loading',
  'platform.navigation-experiences.universal-create.integrations.team.create-error-flag-title':
    'Sorry, something went wrong',
  'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-go-to-team': 'View team',
  'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-title':
    'Team has been created',
  'platform.navigation-experiences.universal-create.project.create-error-flag-description':
    'There was an error while creating your project. Please try again.',
  'platform.navigation-experiences.universal-create.project.create-error-flag-title': "We couldn't create your project",
  'platform.navigation-experiences.universal-create.project.create-success-flag-content': 'Go to project',
  'platform.navigation-experiences.universal-create.project.create-success-flag-title': 'Project has been created',
  'platform.navigation-experiences.universal-create.remote-section-heading': 'Suggestions',
  'platform.navigation-experiences.universal-create.show-less': 'Less',
  'platform.navigation-experiences.universal-create.show-more': 'More',
  'platform.navigation-experiences.universal-create.suggestion.section-heading':
    '{count, plural, one {Suggestion} other {Suggestions}}',
  'universal-create.loom-video-menu-item.create-loom-video': 'Loom video',
  'universal-create.loom-video-menu-item.share-video': 'Share',
};
